/* eslint-disable no-unused-vars */

import { makeStyles, TableCell, TableRow } from '@material-ui/core';
import React, { FC } from 'react';
import { AlternatingColorTableRow } from 'src/components';
import { PurchaseOrderReport } from 'src/redux/slices/purchase-order/types';
import { formatCurrency } from 'src/utils';

interface Props {
  purchaseOrder: PurchaseOrderReport;
  index: number;
}

export const PurchaseOrderTableRow: FC<Props> = ({ purchaseOrder, index }) => {
  const keys = Object.keys(purchaseOrder);
  const values: string[] = Object.values(purchaseOrder).map((i) => String(i));

  return (
    <AlternatingColorTableRow key={index}>
      {values.map((value: string, ind: number) => (
        <TableCell key={ind} align="center">
          {keys[ind] === 'dealer_price' ? formatCurrency(Number(value)) : value}
        </TableCell>
      ))}
    </AlternatingColorTableRow>
  );
};
